@import '../../style/focus-outline.scss';
@import '../com-nav/com-nav-focus.scss';
@import '../../style/breakpoints.scss';

:host {
    --wcs-com-nav-submenu-button-color: var(--wcs-semantic-color-text-primary);
    --wcs-com-nav-submenu-button-font-weight: var(--wcs-semantic-font-weight-medium);
    --wcs-com-nav-submenu-button-focus-outline-color: var(--wcs-semantic-color-border-focus-base);
    --wcs-com-nav-submenu-button-gap: var(--wcs-semantic-spacing-base);

    --wcs-com-nav-submenu-desktop-menu-background-color: var(--wcs-semantic-color-background-surface-primary);
    --wcs-com-nav-submenu-desktop-menu-text-color: var(--wcs-semantic-color-text-primary);
    --wcs-com-nav-submenu-desktop-menu-link-font-weight: var(--wcs-semantic-font-weight-roman);
    --wcs-com-nav-submenu-desktop-menu-heading-font-weight: var(--wcs-semantic-font-weight-heavy);
    --wcs-com-nav-submenu-desktop-menu-description-font-weight: var(--wcs-semantic-font-weight-roman);
    --wcs-com-nav-submenu-desktop-menu-description-gap: var(--wcs-semantic-spacing-base);
    --wcs-com-nav-submenu-desktop-menu-padding: 50px;

    --wcs-com-nav-submenu-desktop-menu-items-padding-left: 50px;
    --wcs-com-nav-submenu-desktop-menu-items-padding-right: 80px;

    --wcs-com-nav-submenu-mobile-text-color: var(--wcs-semantic-color-text-primary);
    --wcs-com-nav-submenu-mobile-link-font-weight: var(--wcs-semantic-font-weight-roman);
    --wcs-com-nav-submenu-mobile-spacing-top: var(--wcs-semantic-spacing-large);
    --wcs-com-nav-submenu-mobile-spacing-bottom: var(--wcs-semantic-spacing-large);
    --wcs-com-nav-submenu-mobile-spacing-left: calc(var(--wcs-semantic-spacing-base) * 3);
    --wcs-com-nav-submenu-mobile-gap: calc(var(--wcs-semantic-spacing-base) * 3);

    display: block;
    padding-bottom: var(--wcs-com-nav-submenu-mobile-spacing-bottom);

    button { // reset button agent styles
        display: block;
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        font: inherit;
        color: inherit;
        cursor: pointer;
    }

    .arrow-icon {
        display: none;
    }

    .arrow-container {
        display: none;
    }

    .label {
        text-transform: uppercase;
        font-size: 16px;
        cursor: unset;
        font-weight: var(--wcs-com-nav-submenu-button-font-weight);
        color: var(--wcs-com-nav-submenu-button-color);
        text-decoration: none;
    }

    .drawer {
        display: contents;
    }

    .drawer-container {
        display: contents;
    }
    .drawer-description {
        display: none;
    }

    .menu-items {
        display: flex;
        flex-direction: column;
        gap: var(--wcs-com-nav-submenu-mobile-gap);

        ::slotted(wcs-com-nav-item) {
            color: var(--wcs-com-nav-submenu-mobile-text-color);
            font-weight: var(--wcs-com-nav-submenu-mobile-link-font-weight);
        }
    }
}

@include for-phone-only {
    :host {
        .menu-button {
            margin: 0;
        }

        .menu-items {
            margin-top: var(--wcs-com-nav-submenu-mobile-spacing-top);
            margin-left: var(--wcs-com-nav-submenu-mobile-spacing-left);
        }
    }
}

@include for-tablet-portrait-up {
    :host {
        height: 100%;
        padding-bottom: unset;

        .menu-button {
            display: flex;
            align-items: center;
            height: 100%;
            cursor: pointer;
            user-select: none;
            font-weight: unset;
            padding-left: unset;
        }

        .menu-button:focus-visible {
            @include focus-outline(var(--wcs-com-nav-submenu-button-focus-outline-color), 2px, 0.1rem);
        }

        @supports not selector(.menu-button:focus-visible) {
            @include focus-outline(var(--wcs-com-nav-submenu-button-focus-outline-color), 2px, 0.1rem);
        }

        .label {
            text-transform: unset;
            cursor: pointer;
        }

        .arrow-icon {
            display: inline-block;
            font-family: icons;
            font-size: 0.6rem;
            line-height: 1;
            box-sizing: border-box;
        }

        .arrow-container {
            display: unset;
            margin-left: var(--wcs-com-nav-submenu-button-gap);
        }

        .arrow-icon:not([data-open]) {
            transform: rotate(90deg);
        }

        .arrow-icon[data-open] {
            transform: rotate(-90deg);
        }

        .drawer {
            display: none;
            position: absolute;
            top: calc(var(--wcs-com-nav-menu-bar-height) + var(--wcs-com-nav-border-width));
            z-index: 8888;
            left: 0;
            width: 100%;
            box-sizing: border-box;
            padding: var(--wcs-com-nav-submenu-desktop-menu-padding);
            background-color: var(--wcs-com-nav-submenu-desktop-menu-background-color);
            color: var(--wcs-com-nav-submenu-desktop-menu-text-color);

            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.08); // TODO: wait solution for backdrop (introduce design token later)
        }

        .drawer-content {
            display: flex;
            justify-content: space-between;
            max-width: 62.5%;
            flex: 1;

            div:first-child {
                flex: 0.8;
            }

            div {
                max-width: 260px;
            }
        }

        .menu-items {
            padding: 0 var(--wcs-com-nav-submenu-desktop-menu-items-padding-right) 0 var(--wcs-com-nav-submenu-desktop-menu-items-padding-left);
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            ::slotted(wcs-com-nav-item) {
                color: var(--wcs-com-nav-submenu-desktop-menu-text-color);
                font-weight: var(--wcs-com-nav-submenu-desktop-menu-link-font-weight);
            }

            ::slotted(wcs-com-nav-item:focus-within) {
                @include com-nav-submenu-item-desktop-focus-outline(var(--wcs-com-nav-submenu-desktop-menu-text-color));
            }
        }

        .drawer-container {
            display: flex;
            max-width: var(--wcs-com-content-max-width);
            margin: 0 auto;

            h3 {
                margin: 0 0 var(--wcs-com-nav-submenu-desktop-menu-description-gap) 0;
                font-size: 1.5rem;
                line-height: 1.25;
                font-weight: var(--wcs-com-nav-submenu-desktop-menu-heading-font-weight);
            }

            p {
                margin-top: 0;
                margin-bottom: 1rem;
                font-weight: var(--wcs-com-nav-submenu-desktop-menu-description-font-weight);
                font-size: 1rem;
                line-height: 1.375;
            }
        }

        .drawer[data-open] {
            display: block;
        }
        .drawer-description {
            display: block;
        }
    }
}
